module.exports = __webpack_public_path__ + "1d77bac4747679bd77fe1ee2d7694d91.png";